import { ChangeEvent, useState } from "react";
import { H6, P } from "../../../../AbstractElements";
import { SavedAddress, ShippingInformation, ShippingMethod } from "../../../../Constant";
import { BillingFormProp } from "../../../../Type/FormLayoutType";
import HomeAndOfficeAddress from "./HomeAndOfficeAddress";
import ShippingMethods from "./ShippingMethods";
import ShowError from "../../common/ShowError";

const ShippingFormContent = ({ callbackActive }: BillingFormProp) => {
  const [radioBoxValues, setRadioBoxValues] = useState({address: "",shippingMethod: "",});
  const { address, shippingMethod } = radioBoxValues;

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = event.target.value;
    setRadioBoxValues({ ...radioBoxValues, [name]: value });
  };

  const handleNextButton = () => {
    if (address !== "" && shippingMethod !== "") {
      callbackActive(3);
    } else {
      ShowError();
    }
  };

  return (
    <>
      <H6>{ShippingInformation}</H6>
      <P className="f-light">Fill up the following information to send you the order</P>
      <div className="shipping-title">
        <H6 className="mb-2">{SavedAddress}</H6>
      </div>
      <HomeAndOfficeAddress radioBoxValues={radioBoxValues} getUserData={getUserData}/>
      <H6 className="mt-4 mb-2">{ShippingMethod}</H6>
      <ShippingMethods radioBoxValues={radioBoxValues} getUserData={getUserData} handleNextButton={handleNextButton}/>
    </>
  );
};

export default ShippingFormContent;
